<!--common component for material design icons-->
<template>
  <component :is="config[icon] ? config[icon].icon: null"
             :style="iconStyle"
             :size="size"
             @click="$emit('click', $event)"
             :title="null">
  </component>
</template>
<script>
import ArrowExpand from 'vue-material-design-icons/ArrowExpandAll.vue'
import ArrowCollapse from 'vue-material-design-icons/ArrowCollapseAll.vue'
import ChartLineIcon from 'vue-material-design-icons/ChartLine.vue'
import Monitor from 'vue-material-design-icons/Monitor.vue'
import Wrench from 'vue-material-design-icons/WrenchOutline.vue'
import Gear from 'vue-material-design-icons/Cogs.vue'
import Key from 'vue-material-design-icons/KeyOutline.vue'
import AccountOutlineIcon from 'vue-material-design-icons/AccountOutline.vue'
import AccountBold from 'vue-material-design-icons/Account.vue'
import LinkVariantIcon from 'vue-material-design-icons/LinkVariant.vue'
import InsertLink from 'vue-material-design-icons/Link.vue'
import CalendarMonthOutlineIcon from 'vue-material-design-icons/CalendarMonthOutline.vue'
import HomeOutlineIcon from 'vue-material-design-icons/HomeOutline.vue'
import LogoutIcon from 'vue-material-design-icons/Logout.vue'
import BookOpenOutlineIcon from 'vue-material-design-icons/BookOpenOutline.vue'
import OpenInNew from 'vue-material-design-icons/OpenInNew.vue'
import FileDocumentOutlineIcon from 'vue-material-design-icons/FileDocumentOutline.vue'
import FilePdfOutline from 'vue-material-design-icons/FilePdfOutline.vue'
import FilePdf from 'vue-material-design-icons/FilePdf.vue'
import ShareVariant from 'vue-material-design-icons/ShareVariant.vue'
import FileOutline from 'vue-material-design-icons/FileOutline.vue'
import MessageReplyText from 'vue-material-design-icons/MessageReplyText.vue'
import Send from 'vue-material-design-icons/Send.vue'
import Magnify from 'vue-material-design-icons/Magnify.vue'
import SortAscending from 'vue-material-design-icons/SortAscending.vue'
import SortDescending from 'vue-material-design-icons/SortDescending.vue'
import CalendarMinus from 'vue-material-design-icons/CalendarMinus.vue'
import StarOutline from 'vue-material-design-icons/StarOutline.vue'
import ContentCopy from 'vue-material-design-icons/ContentCopy.vue'
import DeleteOutline from 'vue-material-design-icons/DeleteOutline.vue'
import Web from 'vue-material-design-icons/Web.vue'
import Domain from 'vue-material-design-icons/Domain'
import LinkBox from 'vue-material-design-icons/LinkBoxVariantOutline.vue'
import ImageBroken from 'vue-material-design-icons/ImageBrokenVariant.vue'
import CameraOutline from 'vue-material-design-icons/CameraOutline.vue'
import MonitorScreenshot from 'vue-material-design-icons/MonitorScreenshot.vue'
import CellphoneScreenshot from 'vue-material-design-icons/CellphoneScreenshot.vue'
import PencilOutline from 'vue-material-design-icons/PencilOutline.vue'
import CheckIcon from 'vue-material-design-icons/Check.vue'
import CloseIcon from 'vue-material-design-icons/Close.vue'
import ImageMultiple from 'vue-material-design-icons/ImageMultiple.vue'
import KeywordReport from 'vue-material-design-icons/Key.vue'
import RankRise from 'vue-material-design-icons/ElevationRise.vue'
import RankDecline from 'vue-material-design-icons/ElevationDecline.vue'
import Launch from 'vue-material-design-icons/Launch.vue'
import Alert from 'vue-material-design-icons/Alert.vue'
import List from 'vue-material-design-icons/ViewList.vue'
import Plus from 'vue-material-design-icons/Plus.vue'
import PlusCircle from 'vue-material-design-icons/PlusCircle.vue'
import FilterIcon from 'vue-material-design-icons/Filter'
import Flash from 'vue-material-design-icons/Flash'
import TableColumnPlusAfter from 'vue-material-design-icons/TableColumnPlusAfter'
import CloseCircle from 'vue-material-design-icons/CloseCircle'
import HelpCircle from 'vue-material-design-icons/HelpCircleOutline'
import TrashCan from 'vue-material-design-icons/TrashCanOutline.vue'
import CommentQuestion from 'vue-material-design-icons/CommentQuestion.vue'
import Comment from 'vue-material-design-icons/CommentText.vue'
import SourceBranch from 'vue-material-design-icons/SourceBranch'
import Email from 'vue-material-design-icons/Email.vue'
import Lock from 'vue-material-design-icons/Lock.vue'
import Description from 'vue-material-design-icons/TextSubject.vue'
import Download from 'vue-material-design-icons/Download'
import DotsVertical from 'vue-material-design-icons/DotsVertical'
import Restore from 'vue-material-design-icons/Restore'
import Upload from 'vue-material-design-icons/Upload'
import FileDocument from 'vue-material-design-icons/FileDocument'
import ContentPaste from 'vue-material-design-icons/ContentPaste'
import ContentSaveOutline from 'vue-material-design-icons/ContentSaveOutline.vue'
import ContentSaveEditOutline from 'vue-material-design-icons/ContentSaveEditOutline.vue'
import Cached from 'vue-material-design-icons/Cached.vue'
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue'
import FileDownloadOutline from 'vue-material-design-icons/FileDownloadOutline.vue'
import CastEducation from 'vue-material-design-icons/CastEducation.vue'
import ImagePlus from 'vue-material-design-icons/ImagePlus.vue'
import ArrowRight from 'vue-material-design-icons/ArrowRight.vue'
import PlusBoxOutline from 'vue-material-design-icons/PlusBoxOutline.vue'
import LightBulbOutline from 'vue-material-design-icons/LightbulbOutline.vue'
import AutoFix from 'vue-material-design-icons/AutoFix.vue'
import Tune from 'vue-material-design-icons/Tune.vue'
import UnfoldMoreHorizontal from 'vue-material-design-icons/UnfoldMoreHorizontal.vue';
import ExportVariant from 'vue-material-design-icons/ExportVariant.vue';
import DotsHorizontal from 'vue-material-design-icons/DotsHorizontal.vue';
import InformationOutline from 'vue-material-design-icons/InformationOutline.vue';
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue';
import CreditCard from 'vue-material-design-icons/CreditCard.vue';
import CreditCardOutline from 'vue-material-design-icons/CreditCardOutline.vue';
// see all available icons here: https://materialdesignicons.com/icon/
/**
 * material design icon
 * the size of icon should be control ether via font-size css property or via size component props
 */
export default {
  name: 'BaseMaterialDesignIcon',
  components: {
    ChartLineIcon,
    AccountOutlineIcon,
    AccountBold,
    LinkVariantIcon,
    CalendarMonthOutlineIcon,
    HomeOutlineIcon,
    LogoutIcon,
    BookOpenOutlineIcon,
    OpenInNew,
    FileDocumentOutlineIcon,
    ShareVariant,
    MessageReplyText,
    Magnify,
    SortAscending,
    SortDescending,
    CalendarMinus,
    StarOutline,
    ContentCopy,
    DeleteOutline,
    Web,
    Domain,
    LinkBox,
    CameraOutline,
    MonitorScreenshot,
    CellphoneScreenshot,
    PencilOutline,
    CheckIcon,
    CloseIcon,
    ArrowCollapse,
    ArrowExpand,
    KeywordReport,
    RankDecline,
    ImageMultiple,  
    RankRise,
    Launch,
    Alert,
    AlertCircleOutline,
    Monitor,
    Gear,
    Key,
    Wrench,
    List,
    Plus,
    PlusCircle,
    FilterIcon,
    Flash,
    TableColumnPlusAfter,
    CloseCircle,
    HelpCircle,
    TrashCan,
    CommentQuestion,
    Comment,
    SourceBranch,
    InsertLink,
    Description,
    Email,
    Lock,
    Download,
    DotsVertical,
    Restore,
    Upload,
    FileDocument,
    ContentPaste,
    ContentSaveOutline,
    Cached,
    ContentSaveEditOutline,
    ChevronRight,
    ChevronDown,
    ChevronLeft,
    FileDownloadOutline,
    FilePdf,
    CastEducation,
    ImagePlus,
    ArrowRight,
    PlusBoxOutline,
    LightBulbOutline,
    AutoFix,
    Tune,
    UnfoldMoreHorizontal,
    ExportVariant,
    DotsHorizontal,
    InformationOutline,
    AlertCircleOutline,
    CreditCard,
    CreditCardOutline
  },
  data () {
    return {
      config: {
        chart: { icon: ChartLineIcon, label: 'Reports' },
        account: { icon: AccountOutlineIcon, label: 'User Management' },
        link: { icon: Web, label: 'Content Briefs' },
        domain: { icon: Domain, label: '' },
        calendar: { icon: CalendarMonthOutlineIcon, label: 'Calendar' },
        home: { icon: HomeOutlineIcon, label: 'Dashboard' },
        logout: { icon: LogoutIcon, label: 'Logout' },
        book: { icon: BookOpenOutlineIcon, label: 'Campaign Guidelines' },
        openInNew: { icon: OpenInNew, label: '' },
        file: { icon: FileDocumentOutlineIcon, label: 'Content Briefs' },
        share: { icon: ShareVariant, label: 'Share' },
        pdf: { icon: FilePdfOutline, label: 'Pdf' },
        attachments: { icon: FileOutline, label: 'Attachments' },
        message: { icon: MessageReplyText, label: '' },
        send: { icon: Send, label: '' },
        search: { icon: Magnify, label: '' },
        sortAsc: { icon: SortAscending, label: '' },
        sortDesc: { icon: SortDescending, label: '' },
        calendarMinus: { icon: CalendarMinus, label: '' },
        star: { icon: StarOutline, label: '' },
        delete: { icon: DeleteOutline, label: '' },
        copy: { icon: ContentCopy, label: '' },
        linkVariant: { icon: LinkVariantIcon, label: '' },
        linkBox: { icon: LinkBox, label: '' },
        imagePlaceholder: { icon: ImageBroken, label: '' },
        camera: { icon: CameraOutline, label: '' },
        desktop: { icon: MonitorScreenshot, label: '' },
        mobile: { icon: CellphoneScreenshot, label: '' },
        edit: { icon: PencilOutline, label: '' },
        check: { icon: CheckIcon, label: '' },
        close: { icon: CloseIcon, label: '' },
        expand: { icon: ArrowExpand, label: '' },
        collapse: { icon: ArrowCollapse, label: '' },
        keywordRankingReport: { icon: KeywordReport, label: '' },
        rankRice: { icon: RankRise, label: '' },
        rankDecline: { icon: RankDecline, label: '' },
        imageMultiple: { icon: ImageMultiple, label: '' },
        searchWeb: { icon: Launch, label: '' },
        alert: { icon: Alert, label: '' },
        monitor: { icon: Monitor, label: '' },
        gear: { icon: Gear, label: '' },
        wrench: { icon: Wrench, label: '' },
        key: { icon: Key, label: '' },
        list: { icon: List, label: '' },
        plus: { icon: Plus, label: '' },
        plusCircle: { icon: PlusCircle, label: '' },
        plusBoxOutline: { icon: PlusBoxOutline, label: '' },
        filter: { icon: FilterIcon, label: '' },
        flash: { icon: Flash, label: '' },
        tableColumnPlusAfter: { icon: TableColumnPlusAfter, label: '' },
        closeCircle: { icon: CloseCircle, label: '' },
        questionCircle: { icon: HelpCircle, label: '' },
        trash: { icon: TrashCan, label: '' },
        chat: { icon: CommentQuestion, label: '' },
        comment: { icon: Comment, label: '' },
        sourceBranch: { icon: SourceBranch, label: '' },
        email: { icon: Email, label: '' },
        password: { icon: Lock, label: '' },
        accountBold: { icon: AccountBold, label: '' },
        insertLink: { icon: InsertLink, label: '' },
        description: { icon: Description, label: '' },
        download: { icon: Download, label: '' },
        dotsVertical: { icon: DotsVertical, label: '' },
        restore: { icon: Restore, label: '' },
        upload: { icon: Upload, label: '' },
        fileDocument: { icon: FileDocument, label: '' },
        paste: { icon: ContentPaste, label: '' },
        save: { icon: ContentSaveOutline, label: '' },
        cached: { icon: Cached, label: '' },
        'save-content': { icon: ContentSaveEditOutline, label: '' },
        arrowRight: { icon: ChevronRight, label: '' },
        arrowDown: { icon: ChevronDown, label: '' },
        arrowLeft: { icon: ChevronLeft, label: '' },
        arrowForward: { icon: ArrowRight, label: '' },
        fileDownload: { icon: FileDownloadOutline, label: '' },
        filePdf: { icon: FilePdf, label: '' },
        education: { icon: CastEducation, label: '' },
        imageUpload: { icon: ImagePlus, label: '' },
        lightBulbOutline: { icon: LightBulbOutline, label: '' },
        autoFix: { icon: AutoFix, label: '' },
        tune: { icon: Tune, label: '' },
        unfoldMoreHorizontal: { icon: UnfoldMoreHorizontal, label: '' },
        exportVariant: { icon: ExportVariant, label: '' },
        dotsHorizontal: { icon: DotsHorizontal, label: '' },
        informationOutline: { icon: InformationOutline, label: '' },
        alertCircleOutline: { icon: AlertCircleOutline, label: '' },
        creditCard: { icon: CreditCard, label: '' },
        creditCardOutline: { icon: CreditCardOutline, label: '' }
      }
    }
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    iconStyle: {
      type: Object,
      default: () => ({})
    },
    size: {
      default: 24
    }
  }
}
</script>
<style lang="scss">
  .icon {
    color: inherit;
  }

  .title {
    font-size: 14px;
    font-weight: 500;
    color: $rfx-dark-march;
    margin-left: 12px;
    white-space: nowrap;
  }

  .header-button-container {
    display: flex;
    align-items: center;
    &:hover {
      color: $rfx-bright-turquoise;
    }
  }

  .material-design-icon {
    cursor: pointer;
    color: $rfx-dark-march;
    font-size: 22px;
  }

  .download-icon {
      &:hover {
        color: $rfx-bright-blue !important;
      }
  }

  .material-design-icon > .material-design-icon__svg {
    bottom: 0 !important;
  }
</style>
